import { MAX_PHONE_NUMBER_LENGTH, DEFAULT_AVAILABLE_COUNTRY_CODES } from './constants.js';
import { generateUniqueId, formatPhoneInternational, removeNonNumbers, parsePhoneNumber, formatPhone, COUNTRY_CODES_TO_DIAL_CODE } from '@doordash/utilities';
import { StackChildren, StackChildrenSize, InlineChildrenAlignment, Text, TextStyle, TextColor } from '@doordash/design-language';
import { PhoneContainer } from './styles.js';
import RawTextField, { RawTextDefaultProps } from '../components/RawTextField.js';
import ErrorMessage from '../components/ErrorMessage.js';
import { FieldSizeSemantic, PhoneFieldSize } from '../constants.js';
import React__default from 'react';
import Select from '../Select.js';
import invariant from 'invariant';
import { formatSelectorOptions } from './countrySelector.js';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var BACKSPACE_KEY = 8;
var PhoneFieldAvailableCountry = Object.keys(COUNTRY_CODES_TO_DIAL_CODE);

var PhoneField = /*#__PURE__*/function (_React$Component) {
  _inherits(PhoneField, _React$Component);

  var _super = _createSuper(PhoneField);

  function PhoneField() {
    var _this;

    _classCallCheck(this, PhoneField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      currentCountry: _this.props.currentCountry || 'US',
      phoneNumber: _this.props.value,
      lastKey: null,
      isFocused: _this.props.autoFocus,
      uniqueId: !!_this.props.id ? _this.props.id : "PhoneField-".concat(generateUniqueId())
    });

    _defineProperty(_assertThisInitialized(_this), "handleCountryChange", function (newCountry, event) {
      _this.setState({
        currentCountry: newCountry
      });

      if (_this.props.onCountryChange) {
        _this.props.onCountryChange(newCountry, _this.props.value, // unformatted number
        formatPhoneInternational(newCountry, _this.props.value), event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handlePhoneFieldChange", function (newValue, event) {
      var currentCountry = _this.state.currentCountry;
      var unformattedNumber = removeNonNumbers(newValue); // below block is needed to remove the country code and to just get the number without country code
      // if we paste this number +61 1900 654 321 / +611900654321, then we are interested only in 1900654321

      var parsedNumber;

      if (_this.props.autoDetectCountry) {
        parsedNumber = parsePhoneNumber(newValue); // if output of parsedPhoneNumber is same as passed value it means phone number parsing failed
        // so preserve unformattedNumber else overwrite it with phone number without country code

        unformattedNumber = parsedNumber === newValue ? unformattedNumber : parsedNumber.nationalNumber; // casting to keep logic intact. Looks like we are validating the type but not in a way TS understands
      } // By default, if a value is something like `"(123)"`
      // then Backspace would only erase the rightmost brace
      // becoming something like `"(123"`
      // which would give the same `"123"` value
      // which would then be formatted back to `"(123)"`
      // and so a user wouldn't be able to erase the phone number.
      // Working around this issue with this simple hack.
      //
      // github.com/catamphetamine/react-phone-number-input/blob/master/source/InputBasic.js#L69-L75


      if (unformattedNumber === _this.state.phoneNumber) {
        if (newValue.indexOf(event.target.value) === 0 && _this.state.lastKey === BACKSPACE_KEY) {
          // Trim the last digit (or plus sign).
          unformattedNumber = unformattedNumber.slice(0, -1);
        }
      } // if auto detect country is enabled
      // and current country is not same as parsed country
      // and parsed country is present in the `availableCountries` prop


      if (_this.props.autoDetectCountry && parsedNumber && parsedNumber.country && parsedNumber.country !== _this.state.currentCountry && // casting all this stuff to get around the `undefined`s because I really don't want
      // to risk messing with this logic and introduce a new bug
      _this.props.availableCountries.indexOf(parsedNumber.country) > -1) {
        currentCountry = parsedNumber.country;

        _this.handleCountryChange(currentCountry, event);
      } // Prevents React from resetting the `<input/>` caret position.
      // https://github.com/reactjs/react-redux/issues/525#issuecomment-254852039
      // github.com/facebook/react/issues/955#issuecomment-469352730


      _this.setState({
        phoneNumber: unformattedNumber
      }, function () {
        _this.props.onChange(unformattedNumber, formatPhoneInternational(currentCountry, newValue), event);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      _this.setState({
        lastKey: event.keyCode
      });

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event);
      }
    });

    return _this;
  }

  _createClass(PhoneField, [{
    key: "componentDidUpdate",
    value: // below block included to keep internal phoneNumber state in sync
    // with provided `value` prop, in case of manual control of field content
    // (like clearing form fields with a button click)
    function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value && this.state.phoneNumber !== this.props.value) {
        this.setState({
          phoneNumber: this.props.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$countryLa = _this$props.countryLabel,
          countryLabel = _this$props$countryLa === void 0 ? 'Country' : _this$props$countryLa,
          _this$props$isInterna = _this$props.isInternationalEnabled,
          isInternationalEnabled = _this$props$isInterna === void 0 ? false : _this$props$isInterna,
          _this$props$available = _this$props.availableCountries,
          availableCountries = _this$props$available === void 0 ? DEFAULT_AVAILABLE_COUNTRY_CODES : _this$props$available,
          _this$props$autoDetec = _this$props.autoDetectCountry,
          autoDetectCountry = _this$props$autoDetec === void 0 ? false : _this$props$autoDetec,
          _this$props$isCountry = _this$props.isCountryFullNameDisplayed,
          isCountryFullNameDisplayed = _this$props$isCountry === void 0 ? false : _this$props$isCountry,
          _this$props$areCountr = _this$props.areCountriesLocaleSorted,
          areCountriesLocaleSorted = _this$props$areCountr === void 0 ? false : _this$props$areCountr,
          _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? RawTextDefaultProps.size : _this$props$size,
          _this$props$isRounded = _this$props.isRounded,
          isRounded = _this$props$isRounded === void 0 ? RawTextDefaultProps.isRounded : _this$props$isRounded,
          isDisabled = _this$props.isDisabled,
          currentCountryProp = _this$props.currentCountry,
          onCountryChange = _this$props.onCountryChange,
          error = _this$props.error,
          value = _this$props.value,
          description = _this$props.description,
          countryFullNameLabelOverrides = _this$props.countryFullNameLabelOverrides,
          preferredCountryCodes = _this$props.preferredCountryCodes,
          hint = _this$props.hint,
          isLabelHidden = _this$props.isLabelHidden,
          props = _objectWithoutProperties(_this$props, ["countryLabel", "isInternationalEnabled", "availableCountries", "autoDetectCountry", "isCountryFullNameDisplayed", "areCountriesLocaleSorted", "size", "isRounded", "isDisabled", "currentCountry", "onCountryChange", "error", "value", "description", "countryFullNameLabelOverrides", "preferredCountryCodes", "hint", "isLabelHidden"]);

      invariant(!autoDetectCountry || isInternationalEnabled, 'You can only use `autoDetectCountry` with `isInternationalEnabled`');
      invariant(!countryFullNameLabelOverrides || isInternationalEnabled, 'You can only provide `countryFullNameLabelOverrides` with `isInternationalEnabled`');
      invariant(!isCountryFullNameDisplayed || isInternationalEnabled, 'You can only provide `isCountryFullNameDisplayed` with `isInternationalEnabled`');
      invariant(!preferredCountryCodes || areCountriesLocaleSorted, 'You can only provide `preferredCountryCodes` with `areCountriesLocaleSorted`.' + "If not using LocaleSort, simply pass in an ordered array of country codes.");

      if (!isInternationalEnabled) {
        return /*#__PURE__*/React__default.createElement(RawTextField, _extends({}, props, {
          size: size,
          isDisabled: isDisabled,
          isRounded: isRounded,
          type: "tel",
          error: error,
          hint: hint,
          description: description,
          value: formatPhone(value),
          onChange: function onChange(newValue, event) {
            return props.onChange(removeNonNumbers(newValue), newValue, event);
          },
          maxLength: MAX_PHONE_NUMBER_LENGTH // 10 #s (potential 11) + "() -"
          ,
          isLabelHidden: isLabelHidden
        }));
      }

      invariant(typeof currentCountryProp !== 'undefined', '`currentCountry` must be provided, PhoneField is a controlled component');
      invariant(typeof onCountryChange !== 'undefined', '`onCountryChange` must be provided, PhoneField is a controlled component');
      var currentCountryState = this.state.currentCountry;
      var currentCountry = currentCountryProp || currentCountryState;
      var phoneNumber = formatPhoneInternational(currentCountry, this.state.phoneNumber);
      var countrySelectorOptions = formatSelectorOptions({
        countryCodes: availableCountries,
        labelOverride: countryFullNameLabelOverrides,
        isCountryFullNameDisplayed: isCountryFullNameDisplayed,
        areCountriesLocaleSorted: areCountriesLocaleSorted,
        preferredCountryCodes: preferredCountryCodes
      });
      var errorElementId = "".concat(this.state.uniqueId, "-error");
      return /*#__PURE__*/React__default.createElement(StackChildren, {
        size: StackChildrenSize.XxSmall
      }, /*#__PURE__*/React__default.createElement(PhoneContainer, {
        alignItems: InlineChildrenAlignment.FlexStart
      }, /*#__PURE__*/React__default.createElement(Select, {
        label: countryLabel,
        options: countrySelectorOptions,
        onChange: this.handleCountryChange,
        value: currentCountry,
        error: !!error,
        size: size,
        isDisabled: isDisabled,
        isRounded: isRounded,
        isLabelHidden: isLabelHidden
      }), /*#__PURE__*/React__default.createElement(RawTextField, _extends({}, props, {
        type: "tel",
        size: size,
        isDisabled: isDisabled,
        isRounded: isRounded,
        error: !!error,
        errorElementId: error && typeof error == 'string' && error.length ? errorElementId : undefined,
        description: description,
        value: this.state.isFocused ? this.state.phoneNumber : phoneNumber.formattedOutput,
        onFocus: function onFocus(event) {
          // prevents the jump of cursor as formatting is applied only when the field is not focused
          _this2.setState({
            isFocused: true
          });

          _this2.props.onFocus && _this2.props.onFocus(event);
        },
        onBlur: function onBlur(event) {
          _this2.setState({
            isFocused: false
          });

          _this2.props.onBlur && _this2.props.onBlur(event);
        },
        onChange: this.handlePhoneFieldChange,
        maxLength: autoDetectCountry ? undefined : MAX_PHONE_NUMBER_LENGTH // as user might paste pre-formatted number, it could go beyond 15 characters
        ,
        onKeyDown: this.handleKeyDown,
        isLabelHidden: isLabelHidden
      }))), error && typeof error === 'string' && error.length && /*#__PURE__*/React__default.createElement(ErrorMessage, {
        id: errorElementId,
        error: error,
        size: size
      }), hint && typeof hint === 'string' && hint.length && /*#__PURE__*/React__default.createElement(Text, {
        styles: TextStyle["".concat(FieldSizeSemantic[size], "Hint")],
        color: TextColor.TextTertiary
      }, hint));
    }
  }]);

  return PhoneField;
}(React__default.Component);

_defineProperty(PhoneField, "AvailableCountries", PhoneFieldAvailableCountry);

_defineProperty(PhoneField, "Sizes", PhoneFieldSize);

_defineProperty(PhoneField, "defaultProps", _objectSpread(_objectSpread({}, RawTextDefaultProps), {}, {
  isInternationalEnabled: false,
  autoDetectCountry: false,
  countryLabel: 'Country',
  availableCountries: DEFAULT_AVAILABLE_COUNTRY_CODES,
  isCountryFullNameDisplayed: false,
  areCountriesLocaleSorted: false
}));

_defineProperty(PhoneField, "DEFAULT_AVAILABLE_COUNTRY_CODES", DEFAULT_AVAILABLE_COUNTRY_CODES);

export { PhoneFieldAvailableCountry, PhoneField as default };
